import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Table from '../common/Table';
import ConstElement from '../common/ConstElement';
import HasPermission from '../helper/user.js';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class EditJob extends Component {
    constructor(props) {
        super(props);
        this.state = {
            job: {work_start_date: null, work_end_date: null,},
            cities:[],
            prefs:[],
            bigCategories:[],
            smallCategories:[],
            hasPermissionCancel:false,
            job_applys: [],
            hasAccepted: false,
        }
        this.saveData = this.saveData.bind(this);
        this.setData = this.setData.bind(this);
        this.getData = this.getData.bind(this);
        this.handleInptChange = this.handleInptChange.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.cancelJob = this.cancelJob.bind(this);
        this.handleChangeEditWorkStartDate = this.handleChangeEditWorkStartDate.bind(this);
        this.handleChangeEditWorkEndDate = this.handleChangeEditWorkEndDate.bind(this);
        this.handleCalculate = this.handleCalculate.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.renderJobImages = this.renderJobImages.bind(this);
        this.renderListOrderHistories = this.renderListOrderHistories.bind(this);
        this.getJobById = this.getJobById.bind(this);
        this.getJobApplys = this.getJobApplys.bind(this);
        this.processClassStatus = this.processClassStatus.bind(this);
        this.processStatus = this.processStatus.bind(this);
        this.generateJobApplyStatus = this.generateJobApplyStatus.bind(this);
        this.saveJobAppliesStatus = this.saveJobAppliesStatus.bind(this);
        this.setGoogleMapSrc = this.setGoogleMapSrc.bind(this)
        this.handlePublicationTypeChange = this.handlePublicationTypeChange.bind(this);
        this.handleChangeEditPostPeriodStartDate = this.handleChangeEditPostPeriodStartDate.bind(this);
        this.handleChangeEditPostPeriodEndDate = this.handleChangeEditPostPeriodEndDate.bind(this);
    }

    /**
     * Init data
     */
    componentWillMount() {
        HasPermission('/api/jobs/delete').then(permission => { this.setState({ hasPermissionCancel: permission }) });
        var callback = () => {
            if (this.state.prefs && this.state.cities && this.state.job.pref && this.state.job.city) {
                this.setGoogleMapSrc(this.state.job);
            }
        };

        axios.get('/api/cities').then(response => {
            this.setState({
                cities: response.data
            },callback);
        })
        axios.get('/api/prefs').then(response => {
            this.setState({
                prefs: response.data
            },callback);
        })
        axios.get('/api/big-categories').then(response => {
            this.setState({
                bigCategories: response.data
            });
        })
        axios.get('/api/small-categories').then(response => {
            this.setState({
                smallCategories: response.data
            });
        })

        if (this.props.match.params.hasOwnProperty('id')) {
            this.getJobById(callback);
        }
    }
    setGoogleMapSrc(job) {
        let googleMapParam = ''
        let tokyoPrefId = [13, 14];
        let pref = this.state.prefs.filter(pref => pref.id == job.pref)[0]
        let city = this.state.cities.filter(city => city.id == job.city)[0]

        if (!pref || !city) {
            return;
        }

        if (tokyoPrefId.indexOf(job.pref) >= 0) {
            googleMapParam = `東京都${city.name}${job.address}`
        } else {
            googleMapParam = `${pref.name}${city.name}${job.address}`
        }
        let src = `https://maps.google.co.jp/maps?q=${googleMapParam}&z=18&output=embed&iwloc=J&t=m`;
        this.setState({ src: src });
    }

    /**
     * Get job applys
     */
    getJobApplys() {
        axios.get('/api/jobs/job-applys/' + this.props.match.params.id)
            .then(response => {
                let hasAccepted = false;
                let jobApplys = response.data.map(jobApply => {
                    if (jobApply['status'] == null) {
                        jobApply['status'] = 'NULL';
                    }
                    //if (jobApply['status'] == 1) {
                    //    hasAccepted = true;
                    //}
                    return jobApply;
                });
                this.setState({hasAccepted: hasAccepted})
                this.setState({job_applys: jobApplys})
            });
    }

    /**
     * Get job by id
     */
    getJobById(callback) {
        const jobId = this.props.match.params.id
        axios.get('/api/jobs/' + jobId).then(response => {
            if (response.data) {
                this.setData(response.data);
                if (callback) {
                    callback
                }
            }
            this.getJobApplys();
        }).catch(() => {
            this.props.history.push('/_404');
        })
    }

    /**
     * Process change work start date
     */
    handleChangeEditWorkStartDate(date) {
        let jobData = Object.assign({}, this.state.job);
        jobData['work_start_date'] = date;
        this.setState({job: jobData});
    }

    /**
     * Process change work end date
     */
    handleChangeEditWorkEndDate(date) {
        let jobData = Object.assign({}, this.state.job);
        jobData['work_end_date'] = date;
        this.setState({job: jobData});
    }

    /**
     * Process change work end date
     */
    handleCalculate(event) {
        let jobData = Object.assign({}, this.state.job);
        jobData['staff_total'] = event.target.value;
        jobData['system_fee'] = Math.floor(jobData['staff_total'] * this.state.job.system_fee_per / 100);
        jobData['staff_price'] = +jobData['staff_total'] - +jobData['system_fee'];
        this.setState({job: jobData});
    }

    /**
     * Set data of job
     * data: Object Job
     */
    setData(data) {
        this.setState({
            job: data
        })
    }

    /**
     * Get data of job
     */
    getData() {
        return this.state.job;
    }

    /**
     * Listen change input
     * event: Object input
     */
    handleInptChange(event) {
        let jobData = Object.assign({}, this.state.job);
        jobData[event.target.name] = event.target.value;
        if (event.target.name === 'staff_total') {
            jobData['system_fee']  = Math.ceil(event.target.value * (jobData['define_system_fee'] / 100));
            jobData['staff_price'] = event.target.value - jobData['system_fee'];
        }

        if (event.target.type === 'checkbox') {
            if (event.target.checked) {
                jobData[event.target.name] = event.target.value;
            } else{
                jobData[event.target.name] = "";
            }
        }
        this.setState({job: jobData});
    }
    handlePublicationTypeChange(event) {
        let jobData = Object.assign({}, this.state.job);
        //set request time
        // 期間指定型はstaff_countは1人固定
        jobData['staff_count'] = 1;
        jobData[event.target.name] = event.target.value;
        this.setState({job: jobData});
    }
    handleChangeEditPostPeriodStartDate(date) {
        let jobData = Object.assign({}, this.state.job);
        jobData['post_period_start_date'] = date;
        this.setState({job: jobData});
    }
    handleChangeEditPostPeriodEndDate(date) {
        let jobData = Object.assign({}, this.state.job);
        jobData['post_period_end_date'] = date;
        this.setState({job: jobData});
    }

    /**
     * Listen change status
     * event: Object input
     */
    handleStatusChange(index, event) {
        let jobApplies = this.state.job_applys;
        jobApplies[index]['status'] = parseInt(event.target.value);
        this.setState({job_applys: jobApplies})
    }

    /**
     * Handle redirect
     */
    handleRedirect(e) {
        e.preventDefault()
        this.props.history.push(e.currentTarget.getAttribute('href'));
    }

    /**
     * Call function save data from element parent
     */
    saveData() {
        let job = this.getData();
        //to top
        window.scrollTo(0, 0)
        if (job.hasOwnProperty('id')) {
            axios.post('/api/jobs/edit/' + job.id, job)
            .then(response => {
                if (response.data.success) {
                    toast.success(response.data.message);
                    this.getJobById();
                } else {
                    Object.keys(response.data.errors).map((key, i) => {
                            if($.isArray(response.data.errors[key])){
                                response.data.errors[key].map((child, i) => {
                                    toast.error(child)
                                })
                            } else {
                                toast.error(response.data.errors[key])
                            }
                        }
                    )
                }
            }).catch(error => {
                Object.keys(error.response.data.errors).map((key, i) => {
                        if($.isArray(error.response.data.errors[key])){
                            error.response.data.errors[key].map((child, i) => {
                                toast.error(child)
                            })
                        } else {
                            toast.error(error.response.data.errors[key])
                        }
                    }
                )
            })
        }
    }

    cancelJob(){
        let job = this.getData();
        if (window.confirm('この依頼をキャンセルしてもよろしいですか？')) {
             //to top
            window.scrollTo(0, 0)
            axios.get('/api/jobs/delete/' + job.id, job).then(response => {
                if (response.data.success) {
                    toast.success(response.data.message);
                    this.setData(response.data.job);
                } else if (response.data.error) {
                    toast.error(response.data.message);
                    this.setData(response.data.job);
                } else {
                    Object.keys(response.data.errors).map((key, i) => {
                            if($.isArray(response.data.errors[key])){
                                response.data.errors[key].map((child, i) => {
                                    toast.error(child)
                                })
                            } else {
                                toast.error(response.data.errors[key])
                            }
                        }
                    )
                }
            }).catch(error => {
                Object.keys(error.response.data.errors).map((key, i) => {
                        if($.isArray(error.response.data.errors[key])){
                            error.response.data.errors[key].map((child, i) => {
                                toast.error(child)
                            })
                        } else {
                            toast.error(error.response.data.errors[key])
                        }
                    }
                )
            })
        }
    }

    /**
     * Handle class with status
     */
    processClassStatus(status) {
        switch(status) {
            case 1:
                return "badge badge-info";
            case 2:
                return "badge badge-danger";
            case 3:
                return "badge badge-warning text-white";
            case 9:
                return "badge badge-dark";
            default:
                return "badge badge-secondary";
        }
    }

    /**
     * Handle show text with status
     */
    processStatus(status) {
        switch(status) {
            case 1:
                return "採用";
            case 2:
                return "不採用";
            case 3:
                return "欠勤";
            case 9:
                return "応募キャンセル";
            default:
                return "未決定";
        }
    }

    /**
     * Generate JobApply status option
     */
    generateJobApplyStatus(jobApply, index) {
        let job = this.getData();
        let options = [
            {value: 'NULL', label: '未決定', disabled: jobApply.disable_status.not_set},
            {value: 1, label: '採用', disabled: jobApply.disable_status.accepted},
            {value: 2, label: '不採用', disabled: jobApply.disable_status.rejected},
            {value: 3, label: '欠勤', disabled: jobApply.disable_status.not_work, style: {display: job.is_houjin_job ? "" : "none"}},
            // {value: 9, label: '応募キャンセル', disabled: true},
        ];

        // If finish eveluation no need to change job apply status
        let isFinishedEvaluation = (jobApply.evaluation_staff && jobApply.evaluation_client && job.status == 5);

        if (isFinishedEvaluation == false) {
            // If job apply status is reject and job status is waiting evaluation
            // no need to change job apply status
            isFinishedEvaluation = jobApply.status == 2 && job.status == 4;
        }

        return (
            <select
              onChange={(event) => {
                this.handleStatusChange(index, event);
              }}
              disabled={isFinishedEvaluation}
              value={jobApply.status}
              className="form-control"
            >
                {options.map((option, i) => {
                    return <option key={i} value={option.value} disabled={option.disabled} style={option.style}>
                        {option.label}
                    </option>;
                })}
            </select>
        );
    }

    renderJobImages() {
        let images = [
            '/img/detail_1.png',
        ];

        if (this.state.job.images_path && this.state.job.images_path.length) {
            images = this.state.job.images_path;
        }

        return (
            <div className="form-group row">
                <label className="col-sm-4 col-form-label text-right">依頼画像</label>
                <div className="col-sm-8">
                    {images.map((img, index) => {
                        return (
                            <img key={index} src={img} width="200" height="200" className="imagePreview img-thumbnail ml-1 mr-1 mb-2" />
                        );
                    })}
                </div>
            </div>
        );
    }

    renderListOrderHistories() {
        let job = this.getData();
        if (job.combini_status == null && !job.is_houjin_job) {
            return (
                <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right">クレジット決済のオーダーID</label>
                    <div className="col-sm-8">
                        <label className="col-value text-left text-primary">
                            <a href={'/history/' + job.clientId}>クレジット決済履歴</a>
                        </label>
                    </div>
                </div>
            );
        }
        return;
    }

    saveJobAppliesStatus() {
        let job = this.getData();
        let payload = this.state.job_applys.map((jobApply) => {
          return {
            id: jobApply.job_applys_id,
            status: jobApply.status,
          };
        });

        axios.put("/api/jobapplys/edit-status/" + job.id, {jobAppliesStatus: payload})
            .then((response) => {
                if (response.data.success) {
                    this.getJobById();
                    this.getJobApplys();
                    toast.success(response.data.message);
                } else {
                    toast.error(response.data.error_messages)
                }
            });
    }

    render() {
        const src = this.state.src
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/home">ダッシュボード</a></li>
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/jobs">依頼一覧</a></li>
                                <li className="breadcrumb-item active" aria-current="page">依頼編集</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <main id="main">
                    <div className="row justify-content-md-center">
                        <div className="col-sm-6">
                          <div className="card">
                            <div className="card-header p-4 border-bottom-0"><h4 className="mb-0">依頼編集</h4></div>
                            <div className="card-body">
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">契約形態</label>
                                    <div className="col-sm-8">
                                        <span className={this.state.job.payment_method == 1 ? 'badge bg-pink text-white mt-1' : 'badge bg-purple text-white mt-1'}>{this.state.job.payment_method == 1 ? '委任' : '直雇用'}</span>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">依頼者</label>
                                    <div className="col-sm-8">
                                        {(this.state.job.first_last_name || (this.state.job.client && this.state.job.client.firstname && this.state.job.client.lastname)) ?
                                            <label className="col-value text-left text-primary"><a href={this.state.job.clientId ? "/accounts/edit/" + this.state.job.clientId : this.state.job.client.id}>{this.state.job.first_last_name ? this.state.job.first_last_name : this.state.job.client.firstname+this.state.job.client.lastname}</a></label>
                                        : ''}
                                    </div>
                                </div>
                                {this.renderListOrderHistories()}
                                <div className={this.state.job.combini_order_id ? '' : 'd-none'}>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">コンビニ決済のオーダーID</label>
                                        <div className="col-sm-8">
                                        <label className="col-value text-left">{this.state.job.combini_order_id}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">コンビニ決済のステータス</label>
                                        <div className="col-sm-8">
                                        <label className="col-value text-left">{this.state.job.combini_status_text}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">タイトル</label>
                                    <div className="col-sm-8">
                                        <span className={this.state.job.category_type==1 ? 'badge bg-pink text-white mt-1' : 'badge bg-purple text-white mt-1'}>{this.state.job.category_type==1 ? 'カテゴリで選ぶ' : '入力する'}</span>
                                    </div>
                                </div>
                                <div >
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">大カテゴリ</label>
                                        <div className="col-sm-8">
                                            <select onChange={this.handleInptChange} name="big_category_id" value={this.state.job.big_category_id ? this.state.job.big_category_id : ''} className="form-control" >
                                                {this.state.bigCategories.map((dataRow, i) => {
                                                    return <option key={i} value={dataRow.id}>{dataRow.name}</option>;
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">小カテゴリ</label>
                                        <div className="col-sm-8">
                                            <select onChange={this.handleInptChange} name="small_category_id" value={this.state.job.small_category_id ? this.state.job.small_category_id : ''} className="form-control" >
                                                {this.state.smallCategories.filter(small_category_id => small_category_id.big_category_id == this.state.job.big_category_id).map((dataRow, i) => {
                                                    return <option key={i} value={dataRow.id}>{dataRow.name}</option>;
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div >
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">フリーカテゴリ</label>
                                        <div className="col-sm-8">
                                            {
                                                React.createElement(
                                                    'input',
                                                    {type: 'text', onChange: this.handleInptChange, name: 'free_category', value: this.state.job.free_category || "", className: 'form-control'},
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">作業日</label>
                                    <div className="col-sm-8">
                                        <input onChange={this.handlePublicationTypeChange} value="2" type="radio" name="publication_type" id="publication_type2" checked={this.state.job.publication_type == 2 || this.state.job.publication_type == null ? 'checked' : ''} />
                                        <label htmlFor="publication_type2" className="ml-1 mr-3">期間指定</label>
                                        <input onChange={this.handlePublicationTypeChange} value="1" type="radio" name="publication_type" id="publication_type1" checked={this.state.job.publication_type == 1 ? 'checked' : ''} />
                                        <label htmlFor="publication_type1" className="ml-1">日付指定</label>
                                    </div>
                                    <div className="col-sm-8 offset-sm-4">
                                        <span>期間指定では、期間中に1回作業を依頼します。</span>
                                    </div>
                                </div>
                                {this.state.job.publication_type == 2 ? (
                                <>
                                    <div className="form-group row">
                                        <label className="col-sm-4 form-label text-right" htmlFor="">期間</label>
                                        <div className="col-sm-2 input-group">
                                            <DatePicker
                                                locale="ja-JP"
                                                className="form-control form_datepicker"
                                                dateFormat="YYYY/MM/DD"
                                                selected={moment(new Date(this.state.job.post_period_start_date))}
                                                selectsStart
                                                onChange={this.handleChangeEditPostPeriodStartDate}
                                                // minDate={moment()}
                                                placeholderText="2023/02/01"
                                                disabledKeyboardNavigation
                                                startDate={moment(new Date(this.state.job.post_period_start_date))}
                                                endDate={moment(new Date(this.state.job.post_period_end_date))}

                                            />
                                            <div className="input-group-append job-input-group-append">
                                                <button className="btn btn-outline-secondary d-none" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                            </div>
                                        </div>
                                        <div className="text-center">
                                            <span>～</span>
                                        </div>
                                        <div className="col-sm-2 input-group">
                                            <DatePicker
                                                locale="ja-JP"
                                                className="form-control form_datepicker"
                                                dateFormat="YYYY/MM/DD"
                                                selected={moment(new Date(this.state.job.post_period_end_date))}
                                                selectsEnd
                                                onChange={this.handleChangeEditPostPeriodEndDate}
                                                // minDate={moment()}
                                                placeholderText="2023/02/28"
                                                disabledKeyboardNavigation
                                                startDate={moment(new Date(this.state.job.post_period_start_date))}
                                                endDate={moment(new Date(this.state.job.post_period_end_date))}

                                            />
                                            <div className="input-group-append job-input-group-append">
                                                <button className="btn btn-outline-secondary d-none" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">時間帯</label>
                                        <div className="col-sm-2">
                                            <ConstElement onElementChange={this.handleInptChange} element="jobs.post_period_start_time" value={this.state.job.post_period_start_time ? this.state.job.post_period_start_time : ''} />
                                        </div>
                                        <div className="text-center">
                                            <span>～</span>
                                        </div>
                                        <div className="col-sm-2">
                                            <ConstElement onElementChange={this.handleInptChange} element="jobs.post_period_end_time" value={this.state.job.post_period_end_time ? this.state.job.post_period_end_time : ''} />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">作業時間(目安)</label>
                                        <div className="col-sm-8">
                                            {
                                                React.createElement(
                                                    'input',
                                                    {type: 'text', onChange: this.handleInptChange, name: 'approximate_time', value: this.state.job.approximate_time|| "", className: 'form-control', placeholder: '15分'}
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">時間帯コメント</label>
                                        <div className="col-sm-8">
                                            <textarea onChange={this.handleInptChange} name="approximate_time_comment" value={this.state.job.approximate_time_comment ? this.state.job.approximate_time_comment : ''} className="form-control" rows="10"></textarea>
                                        </div>
                                    </div>
                                </>
                                ): (
                                <>
                                    <div className="form-group row">
                                        <label className="col-sm-4 form-label text-right" htmlFor="">勤務開始日</label>
                                        <div className="col-sm-8 input-group">
                                            <DatePicker
                                                locale="ja-JP"
                                                className="form-control form_datepicker"
                                                dateFormat="YYYY/MM/DD"
                                                selected={moment(new Date(this.state.job.work_start_date))}
                                                onChange={this.handleChangeEditWorkStartDate}
                                                placeholderText="勤務開始日"
                                                disabledKeyboardNavigation
                                                disabled={this.state.hasAccepted}
                                            />
                                            <div className="input-group-append job-input-group-append">
                                                <button className="btn btn-outline-secondary" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right" htmlFor="">勤務終了日</label>
                                        <div className="col-sm-8 input-group">
                                            <DatePicker
                                                locale="ja-JP"
                                                className="form-control form_datepicker"
                                                dateFormat="YYYY/MM/DD"
                                                selected={moment(new Date(this.state.job.work_end_date))}
                                                onChange={this.handleChangeEditWorkEndDate}
                                                placeholderText="勤務終了日"
                                                disabledKeyboardNavigation
                                                disabled={this.state.hasAccepted}
                                            />
                                            <div className="input-group-append job-input-group-append">
                                                <button className="btn btn-outline-secondary" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">勤務開始時間</label>
                                        <div className="col-sm-8">
                                            <ConstElement onElementChange={this.handleInptChange} is_disabled={this.state.hasAccepted} element="jobs.work_start_time_houjin" value={this.state.job.work_start_time ? this.state.job.work_start_time : ''} />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">勤務終了時間</label>
                                        <div className="col-sm-8">
                                            <ConstElement onElementChange={this.handleInptChange} is_disabled={this.state.hasAccepted} element="jobs.work_end_time" value={this.state.job.work_end_time ? this.state.job.work_end_time : ''} />
                                        </div>
                                    </div>
                                </>
                                )}
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">郵便番号</label>
                                    <div className="col-sm-8">
                                        {
                                            React.createElement(
                                                'input',
                                                {type: 'text', onChange: this.handleInptChange, name: 'zip_no', value: this.state.job.zip_no|| "", className: 'form-control'},
                                        )}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">都道府県</label>
                                    <div className="col-sm-8">
                                        <select onChange={this.handleInptChange} name="pref" value={this.state.job.pref ? this.state.job.pref : ''} className="form-control" >
                                        {this.state.prefs.map((dataRow, i) => {
                                            return <option key={i} value={dataRow.id}>{dataRow.name}</option>;
                                        })}
                                        </select>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">都道府県内全ての市区に掲載</label>
                                    <div className="col-sm-8">
                                        <input onChange={this.handleInptChange} type="checkbox" name="all_cities" value="1" checked={this.state.job.all_cities == 1 ? 'checked' : ''} className="form-checkbox"/>
                                        <p className="text-left text-danger">
                                            ※お仕事詳細での「場所」の表記が都道府県までの表示となります。
                                        </p>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">市区</label>
                                    <div className="col-sm-8">
                                        <select onChange={this.handleInptChange} name="city" value={this.state.job.city ? this.state.job.city : ''} className="form-control" >
                                            {this.state.cities.filter(city => city.pref_id == this.state.job.pref).map((dataRow, i) => {
                                                return <option key={i} value={dataRow.id}>{dataRow.name}</option>;
                                            })}
                                        </select>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right" htmlFor="">町名・番地</label>
                                    <div className="col-sm-8">
                                        {
                                            React.createElement(
                                                'input',
                                                {type: 'text', onChange: this.handleInptChange, name: 'address', value: this.state.job.address|| "", className: 'form-control'},
                                        )}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right" htmlFor="">マップ自動連携</label>
                                    <div className="col-sm-8 offset-sm-4 text-center">
                                        <span>上記の住所に合わせてピンを自動設定しております。</span>
                                        <div className="mt-2">
                                            <input
                                                // onChange={this.handleMapLinkage}
                                                value="1"
                                                type="radio"
                                                name="use_map_flg"
                                                id="use_map_flg1"
                                                checked={this.state.job.use_map_flg == 1 ? 'checked' : ''}
                                                onChange={this.handleInptChange}
                                            />
                                            <label htmlFor="use_map_flg1" className="ml-1 mr-3">このマップを使用する</label>
                                            <input
                                                // onChange={this.handleMapLinkage}
                                                value="0"
                                                type="radio"
                                                name="use_map_flg"
                                                id="use_map_flg2"
                                                checked={this.state.job.use_map_flg == 0 ? 'checked' : ''}
                                                onChange={this.handleInptChange}
                                            />
                                            <label htmlFor="use_map_flg2" className="ml-1">このマップを使用しない</label>
                                        </div>
                                        <div className="">
                                            <iframe frameborder="0" scrolling="auto" marginheight="0" marginwidth="0" src={src} className="w-100"></iframe>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">ビル・建物名</label>
                                    <div className="col-sm-8">
                                        {
                                            React.createElement(
                                                'input',
                                                {type: 'text', onChange: this.handleInptChange, name: 'address2', value: this.state.job.address2|| "", className: 'form-control'},
                                        )}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">最寄駅</label>
                                    <div className="col-sm-8">
                                        {
                                            React.createElement(
                                                'input',
                                                {type: 'text', onChange: this.handleInptChange, name: 'station_name', value: this.state.job.station_name|| "", className: 'form-control'},
                                        )}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">最寄駅まで</label>
                                    <div className="col-sm-8">
                                        {
                                            React.createElement(
                                                'input',
                                                {type: 'text', onChange: this.handleInptChange, name: 'to_station', value: this.state.job.to_station|| "", className: 'form-control'},
                                        )}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">詳細</label>
                                    <div className="col-sm-8">
                                        <textarea onChange={this.handleInptChange} name="note" value={this.state.job.note ? this.state.job.note : ''} className="form-control" rows="8"></textarea>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">詳細補足URL</label>
                                    <div className="col-sm-8">
                                        {
                                            React.createElement(
                                                'input',
                                                {type: 'text', onChange: this.handleInptChange, name: 'job_description_url', value: this.state.job.job_description_url|| "", className: 'form-control', placeholder: ''},
                                        )}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">リンクテキスト</label>
                                    <div className="col-sm-8">
                                        {
                                            React.createElement(
                                                'input',
                                                {type: 'text', onChange: this.handleInptChange, name: 'job_description_text', value: this.state.job.job_description_text|| "", className: 'form-control', placeholder: ''},
                                        )}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">入職経路</label>
                                    <div className="col-sm-8">
                                        <textarea onChange={this.handleInptChange} name="job_detail" value={this.state.job.job_detail ? this.state.job.job_detail : ''} className="form-control" rows="8" disabled></textarea>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">ステータス</label>
                                    <div className="col-sm-8">
                                        <ConstElement onElementChange={this.handleInptChange} element="jobs.status" value={this.state.job.status ? this.state.job.status : ''} />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">募集人数</label>
                                    <div className="col-sm-8">
                                    {this.state.job.publication_type == 2 ? (
                                        <label class="col-value text-left">1人</label>
                                    ) : (
                                        <div className="input-group">
                                            {
                                                React.createElement(
                                                    'input',
                                                    { type: 'text', onChange: this.handleInptChange, name: 'staff_count', value: this.state.job.staff_count || "0", className: 'form-control' },
                                                )}
                                            <div className="input-group-append">
                                                <span className="input-group-text">人</span>
                                            </div>
                                        </div>
                                    )}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">募集金額</label>
                                    <div className="col-sm-8">
                                        <label className="col-value text-left">{this.state.job.staff_price ? '¥' + parseInt(this.state.job.staff_price).toLocaleString() : 0}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">システム利用料</label>
                                    <div className="col-sm-8">
                                        <label className="col-value text-left">{'¥' + parseInt(this.state.job.system_fee).toLocaleString()}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">システム利用料(%)</label>
                                    <div className="col-sm-8">
                                        <label className="col-value text-left">{this.state.job.system_fee_per + '%'}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">合計金額</label>
                                    <div className="col-sm-8">
                                        {this.state.job.clientBillFlag == 1 && <label className="col-value text-left">{this.state.job.staff_total ? '¥' + this.state.job.staff_total : 0}</label>}
                                    {this.state.job.clientBillFlag != 1 && React.createElement('input', {type: 'number', onChange: this.handleInptChange, min: 0, max: 65000, name: 'staff_total', value: this.state.job.staff_total ? this.state.job.staff_total : 0, className: 'form-control'}) }
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">応募人数</label>
                                    <div className="col-sm-8">
                                        <label className="col-value text-left">{this.state.job.apply_count ? this.state.job.apply_count + '人' : '0人'}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">採用人数</label>
                                    <div className="col-sm-8">
                                        <label className="col-value text-left">{this.state.job.recruit_count ? this.state.job.recruit_count + '人' : '0人'}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">請求フラグ</label>
                                    <div className="col-sm-8">
                                        <ConstElement onElementChange={this.handleInptChange} element="jobs.bill_flag" value={this.state.job.bill_flag ? this.state.job.bill_flag : ''} />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">作成日</label>
                                    <div className="col-sm-8">
                                        <label className="col-value text-left">{moment(this.state.job.created_at).format('YYYY-MM-DD HH:mm')}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">編集日</label>
                                    <div className="col-sm-8">
                                        <label className="col-value text-left">{moment(this.state.job.updated_at).format('YYYY-MM-DD HH:mm')}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">値引額</label>
                                    <div className="col-sm-8">
                                        {
                                            React.createElement(
                                                'input',
                                                {type: 'text', onChange: this.handleInptChange, name: 'discount', value: this.state.job.discount || "", className: 'form-control'},
                                        )}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">トラブル区分</label>
                                    <div className="col-sm-8">
                                        <ConstElement onElementChange={this.handleInptChange} element="jobs.trouble_kb" value={this.state.job.trouble_kb ? this.state.job.trouble_kb : ''} />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">メモ</label>
                                    <div className="col-sm-8">
                                        <textarea onChange={this.handleInptChange} name="remark" value={this.state.job.remark ? this.state.job.remark : ""}  className="form-control" rows="8"></textarea>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">web掲載</label>
                                    <div className="col-sm-8">
                                        <ConstElement onElementChange={this.handleInptChange} element="jobs.web_show_flag" value={this.state.job.web_show_flag} />
                                    </div>
                                </div>
                                {this.renderJobImages()}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card-footer">
                                    <div className="text-center">
                                        <button onClick={this.saveData} className="btn btn-primary btn-radius btn-lg clearfix"><span className="size-inherit">保存する</span></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card mt-3">
                            <div className="card-header p-4 border-bottom-0"><h4 className="mb-0">応募者一覧</h4></div>
                            <div className="card-body">
                                <div className="list-group">
                                {this.state.job_applys.length == 0 ? '応募がありません。' :
                                    this.state.job_applys.map((dataRow, i) => {
                                        return <a key={i} className="list-group-item list-group-item-action flex-column align-items-start">
                                                <div className="d-flex w-100 justify-content-between">
                                                    <div className="col-5 pl-0" onClick={this.handleRedirect} href={"/jobapplys/edit/" + dataRow.job_applys_id}>
                                                        <h5 className="mb-1"><span className={this.processClassStatus(dataRow.status)}>{this.processStatus(dataRow.status)}</span> {dataRow.nickname} ({dataRow.first_last_name})</h5>
                                                    </div>
                                                    <div className="col-3">
                                                        {this.generateJobApplyStatus(dataRow, i)}
                                                    </div>
                                                    <div class="col-4 m-2" onClick={this.handleRedirect} href={"/jobapplys/edit/" + dataRow.job_applys_id}>
                                                        <p>作業予定日：{ dataRow.apply_date }</p>
                                                    </div>
                                                </div>
                                                <div class="d-flex justify-content-between" onClick={this.handleRedirect} href={"/jobapplys/edit/" + dataRow.job_applys_id}>
                                                    <p class="mb-1 col-8 p-0">{moment().diff(dataRow.birthday, 'years')}歳　{ dataRow.gender == 1 ? '男性' : dataRow.gender == 2 ? '女性' : '' }</p>
                                                    <p class="col-4 m-2 text-left"><small>評価：{dataRow.evaluation_avg ? dataRow.evaluation_avg.toString().slice(0, 4) : '-'} 実績：{dataRow.evaluation_count ? dataRow.evaluation_count + '件' : '0件'} キャンセル：{dataRow.cancel_apply_count ? dataRow.cancel_apply_count : 0}件</small></p>
                                                </div>
                                            </a>
                                    })
                                }
                                </div>
                            </div>
                        </div>
                        {this.state.job_applys.length == 0 ? '' :
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card-footer">
                                        <div className="text-center">
                                            <button onClick={this.saveJobAppliesStatus} className="btn btn-primary btn-radius btn-lg clearfix"><span className="size-inherit">登録</span></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                </main>
                <ToastContainer />
            </React.Fragment>
        )
    }
}
